import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import authService from '../../services/authService';
import '../../styles/Auth.css';
import Logo from '../../assets/Logo.png';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setEmail(e.target.value);
        if (errors.email) {
            setErrors(prev => ({
                ...prev,
                email: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        setLoading(true);
        try {
            await authService.forgotPassword(email);
            toast.success('Password reset OTP sent to your email!');
            // Redirect to VerifyOTP page with password-reset type
            navigate(`/verify-otp?email=${encodeURIComponent(email)}&type=password-reset`);
        } catch (error) {
            toast.error(error.message || 'Failed to send OTP. Please try again.');
            setErrors({
                submit: error.message || 'Failed to send OTP. Please try again.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-logo">
                    <img src={Logo} alt="Ginni Fashion Studio" />
                </div>
                
                <h1 className="auth-title">Forgot Password?</h1>
                <p className="auth-subtitle">
                    Enter your email address and we'll send you an OTP to reset your password
                </p>

                <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                    <div className="form-group">
                        <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className={`form-input ${errors.email ? 'error' : ''}`}
                            placeholder="Email Address"
                            autoComplete="new-password"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            data-lpignore="true"
                            data-form-type="other"
                        />
                        {errors.email && (
                            <div className="error-message">{errors.email}</div>
                        )}
                    </div>

                    {errors.submit && (
                        <div className="error-message" style={{ textAlign: 'center', marginBottom: '15px' }}>
                            {errors.submit}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className="auth-button"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="loading-spinner"></span>
                                Sending OTP...
                            </>
                        ) : (
                            'Send OTP'
                        )}
                    </button>
                </form>

                <div className="auth-link signup-link">
                    Remember your password? <Link to="/login">Sign in</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;